import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConditionsRegistryService } from '@sdbn/common-extended';
import { EquipmentConditionEditorComponent } from './equipment-condition-editor/equipment-condition-editor.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppServerAPI, CommonUIFieldsModule } from '@sdbn/common';
import { EquipmentType } from '../tmc-common-equipment/common/equipment.model';
import { firstValueFrom } from 'rxjs';



@NgModule({
  declarations: [
    EquipmentConditionEditorComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    CommonUIFieldsModule
  ]
})
export class CommonConditionsModule {

  constructor(
    private appServerAPI: AppServerAPI,
    private conditionsRegistryService: ConditionsRegistryService,
    // private translationService: TranslationService,
    // private tmcContextService: TmcContextService
  ) {

    // this.tmcContextSubscription = this.tmcContextService.updated.subscribe(next => {
    //   if (next != null) {
    //     let transportOptions = new Array<TransportOption>();
    //     for (const to of tmcContextService.getYardConfiguration().transportOptions) {
    //       transportOptions.push(to);
    //       for (const childTo of to.transportOptions) {
    //         transportOptions.push(childTo);
    //       }
    //     }
    //     this.transportOptions = transportOptions;
    //     let tasks = new Array<Task>();
    //     for (const task of tmcContextService.getYardConfiguration().tasks) {
    //       tasks.push(task);
    //     }
    //     this.tasks = tasks;
    //   }
    // });

    this.conditionsRegistryService.registerTemplateGroup({
      titleDictionaryKey: 'tmc-common.ui.conditions.supplementary-equipment',
      anchors: ['equipment'],
      templates: [
        {
          titleDictionaryKey: 'tmc-common.ui.conditions.has-equipment-of-type',
          key: 'has-equipment-of-type',
          iconCss: 'fa-cog',
          editor: EquipmentConditionEditorComponent,
          summaryProvider: async (data: string, language: string) => {
            const response = await firstValueFrom(this.appServerAPI.execute<EquipmentType>('/tmc-common/equipment/getEquipmentType', data));
            if (response) {
              return response.name;
            } else {
              return '';
            }
          }
        }
      ]
    });

  }

}
